<script>
	import Helper from '../../Models/Helper';
	import Slider from '../../States/Slider';

	export let index;

	let element = {};
	let properties = {};
	let active = false;

	function toPericope(name) {
		const base = jQuery(element);
		const selector = `h2[data-anchor="${name}"]`;
		const target = base.find(selector);
		if (target.length) {
			const head = 25;
			const top = target.offset().top - base.offset().top + base.scrollTop() - head;
			base.animate({scrollTop: top}, 1000 * .5);
		}
	}

	function updateSlider(slides) {
		active = Slider.check(index, 'help', properties);
		if (active) {
			properties = Slider.properties(index);
			active = properties.active;
			Helper.title('Help');
		}
	}

	Slider.subscribe(updateSlider);
</script>

<style>
	h1 {
		margin-bottom: 1em;
	}

	h2 {
		color: var(--primary-color) !important;
		margin-top: 2em;
		margin-bottom: 1em;
	}

	div.constraint {
		max-width: 45em;
	}

	p.plain {
		font-size: 1.25em;
		line-height: 1.5em;
		color: var(--secondary-color);
	}

	p a {
		font-weight: bold;
		color: var(--secondary-color);
	}

	a.button {
		text-align: left;
	}

	p i {
		font-size: .75em;
		color: var(--primary-color);
		padding: .5em;
		margin: 0 .25em;
		border-radius: .3em;
		background: var(--secondary-background-light-solid);
	}

	/* Pericopes */

	div.pericopes.list {
		color: var(--secondary-color);
	}

	div.pericopes.list > .item {
		border-bottom: 2px solid var(--tertiary-background-light);
	}

	div.pericopes.list > .item > div {
		line-height: 1.5em;
	}

	div.pericopes.list div.name {
		margin-right: 1em;
	}

	div.pericopes.list div.name i {
		margin-right: 1em;
	}
</style>

<div class="box feature" class:active>
	<div class="menu">
		<div class="begin">
			<div class="title">Help</div>
		</div>
		<div class="end">
			<div class="item" on:click="{event => Slider.close()}">
				<i class="fas fa-times"></i>
			</div>
		</div>
	</div>
	<div class="content" bind:this="{element}">
		<div class="constraint">
			<h1>Help</h1>
			<div class="list pericopes">
				<div class="item" on:click="{event => toPericope('start')}">
					<i class="fad fa-arrow-down"></i>
					<div class="name">
						<i class="fad fa-align-left"></i> Beginnen met lezen
					</div>
				</div>
				<div class="item" on:click="{event => toPericope('icons')}">
					<i class="fad fa-arrow-down"></i>
					<div class="name">
						<i class="fad fa-align-left"></i> Wat zie je in de tekst
					</div>
				</div>
				<div class="item" on:click="{event => toPericope('favorite')}">
					<i class="fad fa-arrow-down"></i>
					<div class="name">
						<i class="fad fa-align-left"></i> Verzen markeren / inloggen
					</div>
				</div>
				<div class="item" on:click="{event => toPericope('search')}">
					<i class="fad fa-arrow-down"></i>
					<div class="name">
						<i class="fad fa-align-left"></i> Verzen of woorden zoeken
					</div>
				</div>
				<div class="item" on:click="{event => toPericope('theme')}">
					<i class="fad fa-arrow-down"></i>
					<div class="name">
						<i class="fad fa-align-left"></i> Donkere of lichte achtergrond
					</div>
				</div>
				<div class="item" on:click="{event => toPericope('zoom')}">
					<i class="fad fa-arrow-down"></i>
					<div class="name">
						<i class="fad fa-align-left"></i> Lettergrootte
					</div>
				</div>
			</div>

			<h2 data-anchor="start">Beginnen met lezen</h2>
			<p>Om te beginnen met lezen, klik je eerst in het menu op de balk “Bijbelboek kiezen”. Je krijgt dan een lijst van de boeken van het Oude Testament, op volgorde van de bijbel. Kies een boek.</p>
			<p>Om naar het Nieuwe Testament te gaan, klik je bovenaan op de balk “Nieuwe Testament” en kies je daar een boek.</p>
			<p>Kies het gewenste hoofdstuknummer of kies in de lijst met titeltjes het gewenste bijbelgedeelte.</p>
			<p>Voor een vorig of volgend hoofdstuk kun je de pijltjestoetsen gebruiken of vegen.</p>
			<p>Je kunt snel naar een ander hoofdstuk binnen hetzelfde bijbelboek navigeren door op het grote hoofdstuknummer bovenaan te klikken. Om deze lijst met hoofstuknummers te sluiten, klik je opnieuw het grote hoofstuknummer aan.</p>
			<p>Wil je naar een ander bijbelboek? Met de knop <i class="fad fa-books"></i> rechtsboven kom je bij een lijst van bijbelboeken op volgorde van de bijbel; met de knop <i class="fad fa-sort-alpha-down"></i> krijg je een lijst van de boeken op alfabetische volgorde.</p>

			<h2 data-anchor="icons">Wat zie je in de tekst</h2>
			<p>De knop <i class="fas fa-question-circle"></i> geeft een stukje uitleg of een verwijzing naar een ander bijbelgedeelte of -vers. Als je de tekstverwijzing hebt aangeklikt, kun je dit bijbelgedeelte weer met het kruisje rechtsboven sluiten of hiervoor de terugtoets van je apparaat gebruiken. Je komt terug bij waar je was met lezen. <i class="fas fa-question-circle"></i> is veranderd in <i class="fas fa-times-circle"></i>. Klik daarop om de uitleg te sluiten.</p>
			<p><i class="far fa-heart"></i> Als je tijdens het lezen op een vers tikt, wordt het versnummer een hartje. Klik op het hartje of direct op het versnummer als je het vers wilt markeren. Het versnummer wordt dan wit op een donkere ondergrond. Als je niets doet, verandert het hartje vanzelf weer in het versnummer. Let op: markeren kan alleen als je ingelogd bent.</p>
			<p><i class="fad fa-share"></i> Bij grotere schermen en de pc staat rechts een kolom met verwijzingen. Deze kun je aanklikken. Met het kruisje rechtsboven of met de terugtoets van je apparaat kom je terug bij waar je was met lezen.</p>
			<p><i class="fad fas fa-location-circle"></i> Dit pijltje aan het begin van een vers geeft aan waar een citaat vandaan komt of waar een parallel bijbelgedeelte staat.</p>
			<p><i class="far fa-bookmark"></i> Rechtsboven zie je een bladwijzer. Als je daarop tikt, kun je de volgende keer dat je de VensterBijbel opent direct bij de bladwijzer verder gaan met lezen. Klik hiervoor in het hoofdmenu op de balk: "Verder lezen”.</p>

			<h2 data-anchor="favorite">Verzen markeren / Inloggen</h2>
			<p>Wil je een vers markeren? Maak eerst een account aan via “Inloggen”. Heb je al een account? Log dan in via “Inloggen”. “Inloggen” vind je door rechtsboven op <i class="fad fa-user"></i> te klikken of op het menu <i class="fad fa-bars"></i> linksboven. Nu kun je verzen markeren.</p>
			<p>Om te markeren klik je op het versnummer: het versnummer wordt wit op een donkere ondergrond.</p>
			<p>Je gemarkeerde verzen kun je terugvinden door in het <i class="fad fa-bars"></i> menu op “Favoriete verzen” te klikken of rechtsboven op <i class="fad fa-book-heart"></i>. Deze knoppen zijn alleen zichtbaar als je ingelogd bent.</p>
			<p>Je verzen staan gesorteerd op bijbelboek, op volgorde van de bijbel. Als je daar een opgeslagen vers opzoekt, kun je er een notitie bij maken door op <i class="fad fa-comment-alt-edit"></i> te klikken. Tik daarna op “Opslaan”.  Ook kun je hier een vers weer uit je favorieten verwijderen. Het versnummer wordt dan weer normaal.</p>
			<p>Je kunt in je lijst Favorieten een vers ook aanklikken om naar het hoofdstuk te gaan waar het staat. Klik dat hoofdstuk weg met het kruisje als je terug wilt naar je lijst Favorieten.</p>

			<h2 data-anchor="search">Verzen of woorden zoeken</h2>
			<p>Zoek je een bepaald woord of vers? Klik op <i class="fad fa-search"></i> en typ je zoekwoord in. Er verschijnt een lijst met alle resultaten. Als je op eentje klikt, kom je in het hoofdstuk waar dat vers staat. Wil je terug naar de lijst? Klik dan op het kruisje. Wil je van de lijst terug naar waar je aan het lezen was? Klik weer op het kruisje.</p>

			<h2 data-anchor="theme">Donkere of lichte achtergrond</h2>
			<p>’s Avonds gaat de website open op een donkere achtergrond, overdag met een lichte. Met <i class="fad fa-lightbulb-on"></i> en <i class="fad fa-lightbulb-slash"></i> kun je zelf wisselen tussen een donkere of lichte ondergrond.</p>

			<h2 data-anchor="zoom">Lettergrootte</h2>
			<p>Met <i class="fad fa-search-plus"></i> en <i class="fad fa-search-minus"></i> kun je de lettergrootte van de leestekst instellen.</p>
		</div>
	</div>
</div>